module.exports = __webpack_public_path__ + "img/icon-contributors.118560ba.svg";